/** Supplier bookkeeping remains in canonical configuration for pricing and
 * fulfilment, but is never a customer choice or quote specification. */
export const SUPPLIER_BOOKKEEPING_OPTION_IDS = ['article_number', 'handling_costs', 'brezo_article', 'summary_image'] as const;
export function isSupplierBookkeepingOption(id: unknown, option?: unknown): boolean {
  const key = String(id ?? '');
  // Only this complete, optional routing contract is proven bookkeeping.
  // Other delivery properties (e.g. customer packaging choices) remain visible.
  if (key === 'delivery' && option && typeof option === 'object') {
    const definition = option as any;
    const values = Array.isArray(definition.values) ? definition.values : null;
    if (String(definition.id || '') === 'delivery' && ['radio', 'select'].includes(String(definition.type || '').toLowerCase()) &&
      (definition.required === false || definition.required === undefined) && values?.length) {
      const ids = values.map((value: any) => String(value?.value ?? value?.id ?? ''));
      if (new Set(ids).size === ids.length && ids.includes('shipping_midocean') && ids.every((value: string) => ['shipping_midocean', 'none'].includes(value))) return true;
    }
  }
  return (SUPPLIER_BOOKKEEPING_OPTION_IDS as readonly string[]).includes(key)
    || /^summary_image(?:$|[:_])/i.test(key);
}
